import { createSlice } from "@reduxjs/toolkit";

export const  userSlice = createSlice({
    name: 'user',
    initialState: {
       user: {
            Id: null,
            FirstName: "",
            LastName: "",
            Email: "",
            RoleId: 3,
            CreatedOn: new Date().toISOString(),
            Attempts: 0,
            Usergpt_key: "LIMITED",
            currentDate: new Date().toISOString(),
            remainingQuestionSets: 5,
            Remainingquestionsetgpt: 0,
            isGptActive: 0,
            version: "Free",
            isPro: false,
            isFree: false,
            isGPT: false,
            isUnlimitedUser: false,
            expiresAt: null
       }
    },
    reducers: {
        setUser(state, action) {
            return { ...state, ...(action.payload?.userData || {}) }
        }
    }
});

export const { setUser } = userSlice.actions;
export default userSlice.reducer;